export default "__VITE_ASSET__oOs95VPC__"